export const platformAccess = {
  junior: {
    required: [
      { platform: 'Figma', access: 'Editor', purpose: 'Design creation and collaboration', setup: 'Request editor access to design team workspace' },
      { platform: 'Slack', access: 'Member', purpose: 'Design team communication', setup: 'Join #product-design, #design-team, #product-team channels' },
      { platform: 'Miro', access: 'Editor', purpose: 'Design thinking and ideation', setup: 'Request editor permissions for design boards' },
      { platform: 'Adobe Creative Cloud', access: 'Individual', purpose: 'Design asset creation', setup: 'Request individual Creative Cloud license' }
    ],
    optional: [
      { platform: 'Sketch', access: 'Individual', purpose: 'UI design (macOS only)', setup: 'Request individual Sketch license for macOS users' },
      { platform: 'InVision', access: 'Viewer', purpose: 'Prototype sharing and feedback', setup: 'Request viewer access to design prototypes' }
    ]
  },
  mid: {
    required: [
      { platform: 'Abstract', access: 'Editor', purpose: 'Design version control and collaboration', setup: 'Request editor access to design version control workspace' },
      { platform: 'Zeplin', access: 'Editor', purpose: 'Design handoff and developer collaboration', setup: 'Request editor permissions for design handoff projects' },
      { platform: 'Amplitude', access: 'Viewer', purpose: 'Product analytics and design impact', setup: 'Request viewer access to product analytics dashboard' },
      { platform: 'Framer', access: 'Individual', purpose: 'Advanced prototyping and interaction design', setup: 'Request individual Framer license' }
    ],
    optional: [
      { platform: 'Hotjar', access: 'Viewer', purpose: 'User behavior analytics', setup: 'Request viewer access to user behavior data' },
      { platform: 'Maze', access: 'Researcher', purpose: 'User testing and validation', setup: 'Request researcher account for user testing platform' }
    ]
  },
  senior: {
    required: [
      { platform: 'Design Operations Platform', access: 'Admin', purpose: 'Enterprise design management and optimization', setup: 'Request admin access to design operations tools' },
      { platform: 'Advanced Analytics Suite', access: 'Admin', purpose: 'Design impact measurement and business intelligence', setup: 'Request admin access to enterprise analytics platform' },
      { platform: 'Design System Platform', access: 'Admin', purpose: 'Enterprise design system management', setup: 'Request admin permissions for design system governance' },
      { platform: 'Enterprise Prototyping Suite', access: 'Admin', purpose: 'Advanced prototyping and design validation', setup: 'Request admin access to enterprise prototyping tools' }
    ],
    optional: [
      { platform: 'Design Intelligence Tools', access: 'Admin', purpose: 'AI-assisted design and automation', setup: 'Request admin access to AI design platforms' },
      { platform: 'Advanced Collaboration Platform', access: 'Admin', purpose: 'Enterprise design collaboration', setup: 'Request admin permissions for collaboration infrastructure' }
    ]
  }
};
